import { VStack, HStack } from "@chakra-ui/layout";
import { PlacementWithLogical, Select, Text, Tooltip } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { SelectOption } from "@models/Order";

interface Props {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	options?: SelectOption[];
	label?: string;
	placeHolder?: string;
	fontSize?: string;
	labelFontWeight?: number;
	width?: number | string;
	bg?: string;
	tooltipIcon?: ReactNode;
	tooltipContent?: string;
	tooltipPlacement?: PlacementWithLogical;
}

const SimpleSelect = ({
	label,
	value,
	onChange,
	options,
	placeHolder = "Välj",
	fontSize = "14px",
	labelFontWeight = 700,
	width = 312,
	bg = "white",
	tooltipIcon,
	tooltipContent,
	tooltipPlacement,
}: Props) => {
	return (
		<VStack width={width} alignItems="start" mr={5} spacing="2">
			<HStack>
				{label && (
					<Text fontSize={fontSize} fontWeight={labelFontWeight} m="0">
						{label}
					</Text>
				)}
				{tooltipIcon && tooltipContent && tooltipPlacement && (
					<Tooltip
						label={tooltipContent}
						placement={tooltipPlacement || "top-end"}
						bg={"#FFFFFF"}
						color={"#999999"}
						borderRadius={"7px"}
					>
						{tooltipIcon}
					</Tooltip>
				)}
			</HStack>
			<Select
				onChange={onChange}
				value={value}
				placeholder={placeHolder}
				fontSize={fontSize}
				borderRadius={"14px"}
				bg={bg}
			>
				{options &&
					options.map((o) => (
						<option key={o.key} value={o.key}>
							{o.value}
						</option>
					))}
			</Select>
		</VStack>
	);
};

export default SimpleSelect;
